import { OperationType } from "../../../utils/settings";

const buildProductInfo = (product, operation_type, quantityMT = 0) => {
  return{
  order_product_delivery_id:
  product.order_product_delivery_id ?? 0,
  operation_type,
  product_id: product.product_id,
  quantity: {
    quantity_in_bags:
      operation_type === OperationType.UPDATE
        ? quantityMT * product?.ordered.multiplier
        : (product?.ordered?.quantity_in_bags ?? product?.quantity?.quantity_in_bags),

    quantity_in_metric_ton:
      operation_type === OperationType.UPDATE
        ? quantityMT
       : (product?.ordered?.quantity_in_metric_ton ?? product?.quantity?.quantity_in_metric_ton),

    multiplier:  (product?.ordered?.multiplier ?? product?.quantity?.multiplier),
    unit:  (product?.ordered?.unit ?? product?.quantity?.unit),
    base_unit:  (product?.ordered?.base_unit ?? product?.quantity?.base_unit),
  },
  form_type: product.form_type ?? 1,
  bundle: product.bundle ?? 0,
}};

export default buildProductInfo;
